export default __webpack_public_path__ + "static/hand-7e16a0d4645a9a4534693cdfd6a9c9b2.webp";